module.exports = __webpack_public_path__ + "img/ky.47007e08.svg";